import { Contract, ethers, formatUnits, JsonRpcSigner } from 'ethers';
import { CDKContract } from '../../contract';
import { UserStake } from '../../../model/round.model';
import { BaseContract } from './base.contract';

export const toCDKToken = (amount: any) => Number(formatUnits(amount, 18));

export const toNumber = (value: any) => Number(BigInt(value));


export abstract class BaseCdkContract extends BaseContract{

    constructor(contract: Contract) {
        super(contract)
    }

    getSignedContract = async (contract: Contract): Promise<CDKContract> => {
        const signedContract = await this._getSignedContract();
        return signedContract as unknown as CDKContract;
    };

}
